module.exports = __webpack_public_path__ + "img/count.6f8c6b95.png";